export default __webpack_public_path__ + "static/media/postSuvinil1.352944d6.png";